const examTypes = [
    {
        "id": "47",
        "name": "ΒΙΟΔΕΙΚΤΕΣ",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "50",
        "name": "ΕΔΟΕΑΠ-Αξονική Τομογραφία",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "51",
        "name": "ΕΔΟΕΑΠ-Γαστρεντερολογία",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "52",
        "name": "ΕΔΟΕΑΠ-Εξετάσεις Βιολογικών Υλικών 1 (Βιοπαθολογίας) (Αιματολογικές, Βιοχημικές, Μικροβιολογικές)",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "55",
        "name": "ΕΔΟΕΑΠ-Υπέρηχοι",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "56",
        "name": "ΕΔΟΕΑΠ-Μαγνητικές Τομογραφίες",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "57",
        "name": "ΕΔΟΕΑΠ-Μαιευτική",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "53",
        "name": "ΕΔΟΕΑΠ-Εξετάσεις Βιολογικών Υλικών 2 (Βιοπαθολογίας και Πυρηνικής Ιατρικής) (Ανοσολογικές, Ορμονολογικές)",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "38",
        "name": "Συνεδρίες Φυσικοθεραπείας (Συμμετοχή 0%)",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "48",
        "name": "ΠΡΟΛΗΠΤΙΚΕΣ ΠΡΟΓΕΝΝΗΤΙΚΟΥ ΕΛΕΓΧΟΥ",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "54",
        "name": "ΕΔΟΕΑΠ-Καρδιολογία",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "58",
        "name": "ΕΔΟΕΑΠ-Ακτινογραφίες",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "59",
        "name": "ΕΔΟΕΑΠ-Κυτταρολογικές",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "60",
        "name": "ΕΔΟΕΑΠ-Οφθαλμολογία",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "1260",
        "name": "Προληπτική εξέταση στο πλαίσιο του Εθνικού Προγράμματος Προσυμπτωματικού Ελέγχου (ΕΠΠΕ)",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "true"
    },
    {
        "id": "0",
        "name": "Test",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "4",
        "name": "Triplex Αγγείων",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "3",
        "name": "Triplex Καρδιάς",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "16",
        "name": "Αγγειογραφίες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "17",
        "name": "Αγγειοχειρουργική",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "6",
        "name": "Ακτινογραφίες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "10",
        "name": "Ακτινοθεραπείες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "18",
        "name": "Αναισθησιολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "1",
        "name": "Αξονική Τομογραφία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "19",
        "name": "Αφροδισιολογία-Δερματολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "20",
        "name": "Γαστρεντερολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "21",
        "name": "Γενικά",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "22",
        "name": "Γυναικολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "7",
        "name": "Εξετάσεις Βιολογικών Υλικών 1 (Βιοπαθολογίας) (Αιματολογικές, Βιοχημικές, Μικροβιολογικές)",
        "active": "true",
        "showWideGroup": "true",
        "notSelectable": "false"
    },
    {
        "id": "8",
        "name": "Εξετάσεις Βιολογικών Υλικών 2 (Βιοπαθολογίας & Πυρηνικής Ιατρικής) (Ανοσολογικές, Ορμονολογικές)",
        "active": "true",
        "showWideGroup": "true",
        "notSelectable": "false"
    },
    {
        "id": "24",
        "name": "Θεραπεία Στειρότητας",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "15",
        "name": "Θεραπείες Πυρηνικής Ιατρικής",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "25",
        "name": "Θωρακοχειρουργική",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "26",
        "name": "Καρδιολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "13",
        "name": "Κυτταρολογικές",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "11",
        "name": "Μαγνητικές Τομογραφίες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "27",
        "name": "Μαιευτική",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "12",
        "name": "Μέτρηση Οστικής Πυκνότητας (Ακτινολογία & Πυρηνικής Ιατρικής)",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "28",
        "name": "Νευρολογία-Ψυχιατρική",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "29",
        "name": "Νεφρολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "30",
        "name": "ΟΔΟΝΤΟΤΕΧΝΙΚΕΣ - ΟΔΟΝΤΙΑΤΡΙΚΕΣ ΠΡΑΞΕΙΣ",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "31",
        "name": "Ορθοπεδική",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "32",
        "name": "Ουρολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "33",
        "name": "Οφθαλμολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "14",
        "name": "Παθολογοανατομικές - Ιστολογικές",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "34",
        "name": "Πνευμονολογία-Φυματιολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "5",
        "name": "Σπινθηρογραφήματα",
        "active": "true",
        "showWideGroup": "true",
        "notSelectable": "false"
    },
    {
        "id": "23",
        "name": "Τοξικολογικές",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "2",
        "name": "Υπέρηχοι",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "9",
        "name": "Φυσικοθεραπείες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "35",
        "name": "Ψυχιατρική",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "36",
        "name": "Ωτορινολαρυγγολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "41",
        "name": "Προληπτική Ιατρική",
        "active": "false",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "42",
        "name": "ΠΡΟΛΗΠΤΙΚΕΣ ΑΚΤΙΝΟΛΟΓΙΑΣ",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "44",
        "name": "ΠΡΟΛΗΠΤΙΚΕΣ ΒΙΟΛΟΓΙΚΩΝ ΥΛΙΚΩΝ  - 2",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "46",
        "name": "ΠΡΟΛΗΠΤΙΚΕΣ  ΓΑΣΤΡΕΝΤΕΡΟΛΟΓΙΑΣ",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "37",
        "name": "Φυσιατρική-Φυσικοθεραπείες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "39",
        "name": "Φυσιατρική-Νευρολογία",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "43",
        "name": "ΠΡΟΛΗΠΤΙΚΕΣ ΒΙΟΛΟΓΙΚΩΝ ΥΛΙΚΩΝ - 1",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "45",
        "name": "ΠΡΟΛΗΠΤΙΚΕΣ  ΚΥΤΤΑΡΟΛΟΓΙΑΣ",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "3000",
        "name": "Γενετικές Εξετάσεις Κληρονομούμενου καρκίνου",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "49",
        "name": "Γονιδιακές εξετάσεις για καρκίνο μαστού",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "64",
        "name": "Λογοθεραπείες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "62",
        "name": "Ψυχοθεραπείες / Θεραπείες Συμπεριφοράς",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "63",
        "name": "Οικογενειακές Ψυχοθεραπείες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "66",
        "name": "Ειδική Διαπαιδαγώγηση",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "65",
        "name": "Εργοθεραπείες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "67",
        "name": "Φυσικοθεραπείες Ειδικής Αγωγής",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    },
    {
        "id": "61",
        "name": "Φυσικοθεραπείες",
        "active": "true",
        "showWideGroup": "false",
        "notSelectable": "false"
    }
]

export const getExamTypesOptions = () => {
    let arr = [];
    const activeOnes = examTypes.filter((el) => el["active"] === "true" && el["notSelectable"] === "false");
    for (const obj of activeOnes) {
        arr.push({
            label: String(obj["name"]),
            value: String(obj["id"]),
        })
    }
    arr.sort((a, b) => String(a.label).localeCompare(b.label, "el"));
    return [{value: "", label: "Κενό"}, ...arr];
}
